// src/pages/Projects.js
import React, { useState, useMemo } from "react";
import Lightbox from "../components/Lightbox";

export default function Projects() {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(null);

  // /media/references/image_1..31, image_6 yok
  // 10 & 23 => .jpeg, 15 & 18 => .svg, diğerleri .png
  const images = useMemo(() => {
    const list = [];
    for (let n = 1; n <= 31; n++) {
      if (n === 6) continue;
      if (n === 15) continue;
      let ext = "png";
      if (n === 5 || n === 10 || n === 23) ext = "jpeg";
      if (n === 15 || n === 18) ext = "svg";
      list.push({ n, src: `/media/references/image_${n}.${ext}` });
    }
    return list;
  }, []);

  const openLb = (img) => {
    // Lightbox için yalın görsel nesnesi
    setActive({
      type: "image",
      src: img.src,
      title: `Referans ${String(img.n).padStart(2, "0")}`,
      date: "",
      desc: ""
    });
    setOpen(true);
  };

  const closeLb = () => {
    setOpen(false);
    setActive(null);
  };

  return (
    <section className="section">
      <div className="container">
        <header className="section-head">
          <h1 className="page-title">Referanslar</h1>
          <p className="page-subtitle">Geçmiş işlerimizden seçkiler.</p>
        </header>

        <div className="projects-grid refs-white">
          {images.map((img) => (
            <figure
              key={img.src}
              className="project-card only-image"
            >
              <div className="project-thumb-box">
                <img
                  src={img.src}
                  alt={`Referans görseli ${String(img.n).padStart(2, "0")}`}
                  loading="lazy"
                  decoding="async"
                  width="640"
                  height="360"
                  sizes="(max-width: 680px) 90vw, (max-width: 980px) 45vw, 400px"
                  className="project-thumb-img contain"
                  draggable="false"
                />
              </div>
            </figure>
          ))}
        </div>

        <div className="cta services-cta" style={{ marginTop: 24 }}>
          <h3>Projeniz için fiyat teklifi alın</h3>
          <p>Kısa bir açıklama paylaşın, aynı gün dönüş sağlayalım.</p>
          <a className="btn primary" href="/contact#form">
            İletişime Geç
          </a>
        </div>
      </div>

      <Lightbox open={open} onClose={closeLb} item={active} />
    </section>
  );
}